import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import ShopTypeEdit from './ShopTypeEdit';
import { Button, Space, Switch, Tooltip } from 'antd';
import MenuSaleDate from '../menu/MenuSaleDate';
import { useContext, useEffect, useRef, useState } from 'react';
import { SocketContext } from '../../../App';
import MenuIcon from './MenuIcon';

export default function ShopType(props: any) {

    const ref = useRef<any>(undefined);

    //销售/折扣时间窗口
    const [menuSaleDateVisible, setMenuSaleDateVisible] = useState(false);

    //销售/折扣时间数据
    const [menuSaleDateData, setMenuSaleDateData] = useState<any>();

    //图标窗口
    const [menuIconVisible, setMenuIconVisible] = useState(false);

    //图标数据
    const [menuIconData, setMenuIconData] = useState<any>();

    /** api服务id */
    const apiId = 'shopType';

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    const onRefresh = (item: any) => {
        const { branchStoreId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                branchStoreId
            }
        }
        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }

    //表头
    const columnsHead = [
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.shopCategory.branchStore.brand.brandName + " " + record.shopCategory.branchStore.branchStoreName}</div>
                )
            }
        },
        {
            title: '大分类',
            dataIndex: 'shopCategoryName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.shopCategory.shopCategoryName}</div>
                )
            }
        },
        {
            title: '小分类名称',
            dataIndex: 'shopTypeName',
        },
        {
            title: '小分类英文',
            dataIndex: 'shopTypeNameEn',
        },
        {
            title: '销售/折扣时间',
            dataIndex: 'menuSaleDate',
            key: 'menuSaleDate',
            render: (text: any, record: any) => {
                if (record.menuSaleDates) {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => handleMenuSaleDate(record)}>销售/折扣时间</Button>
                        </Space>
                    )
                }
                else {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" danger onClick={() => handleMenuSaleDate(record)}>销售/折扣时间</Button>
                        </Space>
                    )
                }
            }
        },
        {
            title: '图标',
            dataIndex: '',
            key: 'menuIcon',
            render: (text: any, record: any) => {
                return (
                    <Space size="small">
                        <Button size={"small"} type="primary" onClick={() => handleMenuIcon(record)}>图标</Button>
                    </Space>
                )
            }
        },
        {
            title: '客服专用',
            dataIndex: 'isStaff',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                // onChange={(e) => handleChange(record.id, 'isStaff', e)}
                />
            )
        },
        {
            title: '打折',
            dataIndex: 'isDiscount',
            render: (text: any, record: any) => {
                if (record.isDiscount) {
                    return (
                        <Tooltip placement="topLeft" title={'当前折扣为 ' + record.maxDiscount} color='red'>
                            <Switch checkedChildren="是" unCheckedChildren="否"
                                checked={text} key={record.id}
                            />
                        </Tooltip>
                    )
                }
                else {
                    return (
                        <Switch checkedChildren="是" unCheckedChildren="否"
                            checked={text} key={record.id}
                        />
                    )
                }
            }
        },
        // {
        //     title: '最高折扣',
        //     dataIndex: 'maxDiscount',
        // },
        // {
        //     title: '排序',
        //     dataIndex: 'sortBy',
        // },
    ];

    //打开销售/折扣时间页面
    const handleMenuSaleDate = (record: any) => {
        //console.log(record)
        sendData.targetId = record.id;
        sendData.targetKey = 'shopType';
        sendData.title = record.shopTypeName;
        setMenuSaleDateData(sendData);
        setMenuSaleDateVisible(true);
    };

    //关闭销售/折扣时间页面
    const onCloseMenuSaleDate = async (status: boolean) => {
        setMenuSaleDateVisible(false);
        if (status) {
            await initData();
        }
    }

    //打开添加图标
    const handleMenuIcon = async (record: any) => {
        // console.log(record);
        sendData.id = record.id;
        sendData.path = 'ShopType';
        setMenuIconData(sendData);
        setMenuIconVisible(true);
    };

    //关闭图标页面
    const onCloseMenuIcon = async (status: boolean) => {
        setMenuIconVisible(false);
        if (status) {
            await initData();
        }
    }

    const initData = async () => {
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                branchStoreId: contextData?.currentBranchStoreId
            }
        }
        ref.current.initData(currentData);
    }

    const columns = columnsheadId
        .concat(columnsHead as []);

    //传关参数
    let sendData = {
        type: 'EDIT',
        id: '',
        path: '',
        title: '',
        targetId: '',
        targetKey: ''
    }

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '菜谱分类',
        apiId: 'shopType',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: ShopTypeEdit,
        // sendPageData: { branchStoreId: localStorage.getItem("currentBranchStoreId") },
        sendPageData: { branchStoreId: contextData?.currentBranchStoreId },
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>

            {menuSaleDateVisible
                ? (<MenuSaleDate
                    closeModal={onCloseMenuSaleDate} data={menuSaleDateData} />)
                : null}

            {menuIconVisible
                ? (<MenuIcon
                    closeModal={onCloseMenuIcon} data={menuIconData} />)
                : null}
        </>
    )
}